export const hexToRGBA = (hex: string, alpha = 1, lightRatio = 1) => {
  const rgb = hexToRGB(hex, lightRatio);
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
};

export const hexToRGB = (hex: string, lightRatio = 1) => {
  const r = 255 - lightRatio * (255 - parseInt(hex.slice(1, 3), 16));
  const g = 255 - lightRatio * (255 - parseInt(hex.slice(3, 5), 16));
  const b = 255 - lightRatio * (255 - parseInt(hex.slice(5, 7), 16));

  return { r, g, b };
};

export const getLuminance = (r: number, g: number, b: number) => {
  return 0.299 * r + 0.587 * g + 0.114 * b;
};

export const sortHexBasedOnLuminance = (hex1: string, hex2: string) => {
  const rgb1 = hexToRGB(hex1);
  const rgb2 = hexToRGB(hex2);

  return getLuminance(rgb1.r, rgb1.g, rgb1.b) - getLuminance(rgb2.r, rgb2.g, rgb2.b);
}
